import axios from 'axios';

export function getAreasByType(typeId) {
  const params = new URLSearchParams();
  params.append("areaTypeId", typeId);
  return axios.get('/area', {
    params: params
  })
}